/**
 * ERP Advanced API — changes, kudos, pulse, okr, compensation, bradford.
 */

import { apiFetch } from './core'

export const erpAdvanced = {
    changes: {
        list: (params = {}) => {
            const qs = new URLSearchParams(params).toString()
            return apiFetch(`/erp-advanced/changes${qs ? `?${qs}` : ''}`)
        },
        create: (data) => apiFetch('/erp-advanced/changes', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
        apply: (id) => apiFetch(`/erp-advanced/changes/${id}/apply`, { method: 'POST' }),
    },
    kudos: {
        list: (params = {}) => {
            const qs = new URLSearchParams(params).toString()
            return apiFetch(`/erp-advanced/kudos${qs ? `?${qs}` : ''}`)
        },
        send: (data) => apiFetch('/erp-advanced/kudos', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
        leaderboard: () => apiFetch('/erp-advanced/kudos/leaderboard'),
    },
    pulse: {
        questions: () => apiFetch('/erp-advanced/pulse/questions'),
        submit: (data) => apiFetch('/erp-advanced/pulse/respond', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
        overview: () => apiFetch('/erp-advanced/pulse/overview'),
        seedQ12: () => apiFetch('/erp-advanced/pulse/seed-q12', { method: 'POST' }),
    },
    okr: {
        list: (params = {}) => {
            const qs = new URLSearchParams(params).toString()
            return apiFetch(`/erp-advanced/okr${qs ? `?${qs}` : ''}`)
        },
        create: (data) => apiFetch('/erp-advanced/okr', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
        updateKR: (krId, data) => apiFetch(`/erp-advanced/okr/kr/${krId}`, {
            method: 'PATCH',
            body: JSON.stringify(data),
        }),
    },
    compensation: {
        bands: () => apiFetch('/erp-advanced/compensation/bands'),
        createBand: (data) => apiFetch('/erp-advanced/compensation/bands', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
        compaRatio: () => apiFetch('/erp-advanced/compensation/compa-ratio'),
    },
    bradford: {
        list: (params = {}) => {
            const qs = new URLSearchParams(params).toString()
            return apiFetch(`/erp-advanced/bradford${qs ? `?${qs}` : ''}`)
        },
        create: (data) => apiFetch('/erp-advanced/bradford', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
        report: () => apiFetch('/erp-advanced/bradford/report'),
    },
    turnover: {
        overview: (months) => apiFetch(
            `/erp-advanced/turnover/overview${months ? `?months=${months}` : ''}`,
        ),
    },
    team: {
        // Состав команд и Белбин-роли по РЕАЛЬНЫМ результатам теста.
        // До этой ручки страница `/teambuilder` роли не спрашивала вовсе:
        // считала хеш от UUID сотрудника.
        belbin: () => apiFetch('/erp-advanced/team/belbin'),
    },
}
